
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
// import moment from 'moment';
import { LoginCommand } from '../../../models/api-models';
import { HttpHeaders } from '@angular/common/http';
import { ApisService } from '../../../services/apis.service';
import { AppConstants } from '../../../app-constants';
import moment from 'moment';
import { SharedService } from '../../../services/shared.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertDialogComponent } from '../../../shared/alert-dialog/alert-dialog.component';
import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FromFieldType } from '../../../models/form-field.model';
import { MustMatch } from '../../../infrastructure/helpers/must-match.validator';
import { DynamicFormBuilderComponent } from '../../../shared/dynamic-form-builder/dynamic-form-builder.component';

@Component({
  selector: 'app-login',
  imports: [FormsModule, ReactiveFormsModule, AlertDialogComponent,DynamicFormBuilderComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  @ViewChild('alert') alert!: AlertDialogComponent; 
  @ViewChild('changesPassword') changePasswordTemplate!: TemplateRef<any>;
forgetPassword_fields:FromFieldType[]=AppConstants.field_names.forgetPassword_fields
 currentYear = new Date().getFullYear();
changePasswordForm!:FormGroup
  showPassword!: boolean;
  loginForm!: FormGroup
  confirmEmailForm!: FormGroup
  loginErrorMsg: any;
  emailID: any;
  modalRef!: NgbModalRef;
  constructor(private fb: FormBuilder, private router: Router, private apis: ApisService, private sharedService: SharedService, private toasterService: ToastrService, private modalService: NgbModal) { }
  ngOnInit() {
    this.loginForm = this.fb.group({
      userName: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    })
    this.confirmEmailForm = this.fb.group({
      emailId: ['', [Validators.required, Validators.email]],
    })
    this.generateUUIDV4()
    this.getChangesPassworsdForm()
  }
     getChangesPassworsdForm() {
      let fieldsCtrls = {} as any;
      for (let f of this.forgetPassword_fields) {
       
        fieldsCtrls[f.name] = new FormControl(f.value || '', f.required == true ? Validators.required : [])
      }
 this.changePasswordForm = new FormGroup(fieldsCtrls, {
    validators: MustMatch('newPassword', 'confirmPassword')
  } as any);
    }
  generateUUIDV4() {
    // http://www.ietf.org/rfc/rfc4122.txt
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';  // bits 12-15 of the time_hi_and_version field to 0010
    // eslint-disable-next-line no-bitwise
    s[19] = hexDigits.substr((s[19] as any & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';

    const uuid = s.join('');
    localStorage.setItem('deviceId', uuid);
  }
  login() {
    //  this.router.navigate(['/admin/dashboard']);
    if (!this.loginForm.invalid) {
      console.log("Inside login method if consition")
      let body: LoginCommand =
      {
        username: this.loginForm.value.userName,
        password: this.loginForm.value.password,
        activitytimeStamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

      console.log("step 1 login", body)
      const httpOptions = {
        headers: new HttpHeaders({
          'osVersion': '',
          'appVersion': '',
          'environment': 'web',
          'buildNumber': '',
          'Content-Type': 'application/json',
          'activitytime': '2020-12-01 18:22:43',
          'timezone': '+5:30',
          'isloggedin': '0'
        })
      };

      this.apis.postApi(AppConstants.apis_end_points.login, this.sharedService.apis_encrypt(body), httpOptions).subscribe({
        next: data => {
          console.log(data)
          data = this.sharedService.apis_decrypt(data)
          console.log(data)
          if (data.success == 1) {
            this.sharedService.setSession(AppConstants.LocalStorage.LoggedUserDetails, data.userDetails);
            this.sharedService.setSession(AppConstants.LocalStorage.loggedAccountDetails, data.accountDetails);
            this.sharedService.setSession(AppConstants.LocalStorage.IsLoggedIn, AppConstants.Booleans.True);
            this.toasterService.success('', 'User logged in.');
            this.router.navigate([AppConstants.RoutingPaths.dashboard]);
            // this.router.navigate([AppConstants.RoutingPaths.dashboard]);
          } else {
            console.log(data)
            //  this.toasterService.error('', data.message);
            this.loginErrorMsg = data.message
            this.alert.showDialog();
          }
        },
        error: data => {
          console.log(data.error)
           const data1 = this.sharedService.apis_decrypt(data.error)
             console.log(data1)
          this.loginErrorMsg = data1.message
          //  this.toasterService.error('', err.error.message);
          this.alert.showDialog();
        }

      })
    }

  }
  openForgotPassword(content: any) {
    this.confirmEmailForm.reset()
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      windowClass: 'forgotPassword',
    })

  }
 forgotPasswordModel() {
   this.emailID= this.confirmEmailForm.value.emailId
    if (!this.confirmEmailForm.invalid) {
      var body = {
        email: this.confirmEmailForm.value.emailId,
        current_date_time: moment().format('YYYY-MM-DD HH:mm:ss')
      };
      const httpOptions = {
        headers: new HttpHeaders({
          errortoast: '1',
          'Content-Type': 'application/json',
        }),
      };
      this.apis.postApi(AppConstants.apis_end_points.login_email_exists, this.sharedService.apis_encrypt(body), httpOptions).subscribe((item: any) => {
        item = this.sharedService.apis_decrypt(item)
        console.log(item)
        if (item.success == 1) {
          this.confirmEmailForm.reset();
          this.toasterService.success('', item.message);
          this.modalService.dismissAll('forgotpassword');
          this.openchangesPassword()
        } else {
          this.toasterService.error('', item.message);
        }
      })
    }
  }
    openchangesPassword() {
      this.changePasswordForm.reset()
  this.modalRef = this.modalService.open(this.changePasswordTemplate, {
    ariaLabelledBy: 'modal-basic-title',
    centered: true,
    windowClass: 'change-password'
  });

  }
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
 resetPassword(){
     let body = {
        otp: this.changePasswordForm.value.SecurityCode,
        email: this.emailID,
        password: this.changePasswordForm.value.newPassword,
        ip_address: localStorage.getItem('deviceId')
      };
      console.log(body)
      this.apis.postApi(AppConstants.apis_end_points.login_reset_password, this.sharedService.apis_encrypt(body), {}).subscribe((data:any)=>{
        data=this.sharedService.apis_decrypt(data)
        console.log(data)
        if(data.success ==1){
            this.toasterService.success('', data.message);
               this.modalService.dismissAll('changesPassword');
        }else{
           this.toasterService.error('', data.message);
        }
      })
 }
 cancelBtnResetPwd(){
 this.modalRef.close();
 }
}
